import React from "react";
import { motion } from "framer-motion";
import { appleLogin, facebookLogin, googleLogin, useAppDispatch } from "../../../redux";
import { useGoogleLogin } from "@react-oauth/google";
import { appleAuthHelpers } from "react-apple-signin-auth";
import AppleSignin from "react-apple-signin-auth";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"; // custom render
import { ApplePayload, RoleEnum } from "../../shared/model";
import { useLocation } from "react-router-dom";
const SocialLogins = (props?: any) => {

    const location = useLocation();
    
    const dispatch = useAppDispatch();
    const googleLoginApi = useGoogleLogin({
        onSuccess: tokenResponse => {
            try {
                dispatch(googleLogin({ idToken: tokenResponse.access_token, userRole: props.role }));
            } catch (error) {
                alert("Something went wrong");
            }
    

        },
    });

    const handleAppleLogin = async (response) => {
        try {
            if (response && response.authorization) {
                const body = {} as ApplePayload;
                body.idToken = response.authorization.id_token;
                body.userRole = props.role;
                if (response.user && response.user.name) {
                    body.firstName = response.user.name.firstName;
                    body.lastName = response.user.name.lastName;
                }
                dispatch(appleLogin(body));
            }
        } catch (error) {
            alert("Something went wrong");
        }
    };
    // Facebook login callback
    const handleFacebookCallback = (response: any) => {
        try {
            if (response?.status === "unknown") {
                return;
            }
            dispatch(facebookLogin({ accessToken: response.accessToken, userRole: props.role }));
        } catch (error) {
            alert("Something went wrong");
        }

    };
    return (
        <>
            <div className="grid grid-cols-2 gap-4">
                <motion.button
                    disabled={location.pathname === "/auth/register" && !props.role}
                    whileHover={{ scale: 1.02 }}
                    onClick={() => googleLoginApi()}
                    whileTap={{ scale: 0.98 }}
                    className="flex items-center justify-center gap-2 p-2.5 border rounded-lg hover:bg-gray-50 transition-colors">
                    <img
                        src="https://img.icons8.com/?size=100&id=17949&format=png&color=000000"
                        alt="Google"
                        className="w-5 h-5"
                    />
                    <span className="text-sm font-medium">Google</span>
                </motion.button>
                <AppleSignin
                    render={(renderProps: any) => (
                        <motion.button
                            disabled={location.pathname === "/auth/register" && !props.role}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={renderProps.onClick}
                            className="flex items-center justify-center gap-2 p-2.5 border rounded-lg hover:bg-gray-50 transition-colors">
                            <img
                                src="https://img.icons8.com/?size=100&id=30840&format=png&color=000000"
                                alt="Facebook"
                                className="w-5 h-5"
                            />
                            <span className="text-sm font-medium">Apple</span>
                        </motion.button>
                    )}
                    /** Auth options passed to AppleID.auth.init() */
                    authOptions={{
                        /** Client ID - eg: 'com.example.com' */
                        clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                        usePopup: true,
                        /** Requested scopes, seperated by spaces - eg: 'email name' */
                        scope: "email name",
                        /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
                        redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI,
                        /** State string that is returned with the apple response */
                        state: "state",
                        /** Nonce */
                        nonce: "nonce",
                        /** Uses popup auth instead of redirection */
                    }} // REQUIRED

                    uiType="light"
                    className="flex items-center justify-center gap-2 p-2.5 border rounded-lg hover:bg-gray-50 transition-colors apple-auth"
                    buttonExtraChildren="Apple"
                    onSuccess={response => handleAppleLogin(response)} // default = undefined
                    /** Called upon signin error */
                    onError={error => {}} // default = undefined
                />
            </div>

            {/* Facebook Button using custom render */}
            <div className="grid grid-cols-2 gap-4">
                <FacebookLogin
                    appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                    autoLoad={false}
                    fields="name,email,picture"
                    callback={handleFacebookCallback}
                    render={(renderProps: any) => (
                        <motion.button
                            disabled={location.pathname === "/auth/register" && !props.role}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={renderProps.onClick}
                            className="flex items-center justify-center gap-2 p-2.5 border rounded-lg hover:bg-gray-50 transition-colors">
                            <img
                                src="https://img.icons8.com/?size=100&id=118497&format=png&color=000000"
                                alt="Facebook"
                                className="w-5 h-5"
                            />
                            <span className="text-sm font-medium">Facebook</span>
                        </motion.button>
                    )}
                />
            </div>


            {/* <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => handleAppleLogin()}
                className="w-[48%] flex items-center justify-center gap-2 p-2.5 border rounded-lg hover:bg-gray-50 transition-colors">
                <img
                    src="https://img.icons8.com/?size=100&id=30840&format=png&color=000000"
                    alt="Apple"
                    className="w-5 h-5"
                />
                <span className="text-sm font-medium">Apple</span>
            </motion.button> */}
        </>
    );
};

export default SocialLogins;